import { Component, Inject, Input } from '@angular/core';
import { gtpRutValidator } from 'src/app/shared/validators/rut-validator';
import { SolicitudCreditoServiceWorkflow } from 'src/app/shared/services/solicitud-credito-workflow.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UtilsService } from 'src/app/shared/services/utils.service';

export interface ConfirmModel {
  entidades: any[];
  contratoEntidades: any[];
  idTransaccion: string;
  rut: string;
}

interface ElementForm {
  entidadId: string;
  entidad: string;
  form: UntypedFormGroup;
  outputVars: any[];
}

interface Eliminable {
  entidadId: string;
  entidad: string;
  searchTerm: string;
  ruts: RutEliminable[];
  rutsVisibles: RutEliminable[];
  pagina: number;
}

interface RutEliminable {
  rut: string;
  isNatural: boolean;
  seleccionado: boolean;
}

@Component({
  selector: 'app-modal-entidades-workflow',
  templateUrl: './modal-entidades-workflow.component.html',
  styleUrls: ['./modal-entidades-workflow.component.scss']
})
export class ModalEntidadesWorkflowComponent {
  @Input() entidades: any[] = [];
  @Input() contratoEntidades: any[] = [];
  @Input() rut: string = '';
  @Input() idTransaccion: string = '';

  public messages: { text: string, isError: boolean, isSuccess: boolean }[] = [];
  public mostrarFormulario: boolean = true;

  public entidadSeleccionada: string = '';
  public entidadesSeleccionables: any[] = [];
  public formComponent: ElementForm[] = [];

  public eliminables: Eliminable[] = [];

  private responseApi: any = null;

  constructor(public dialogRef: MatDialogRef<ModalEntidadesWorkflowComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmModel, 
    private formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService,
    private utilsService: UtilsService,
    private solicitudCreditoService: SolicitudCreditoServiceWorkflow
  ) {
    this.entidades = this.data?.entidades || [];
    this.contratoEntidades = this.data?.contratoEntidades || [];
    this.rut = this.data?.rut || '';
    this.idTransaccion = this.data?.idTransaccion || '';
    this.setEntidadesSeleccionables();
    this.setEliminables();
  }

  setEntidadesSeleccionables(): void {
    if(!this.contratoEntidades || this.contratoEntidades.length <= 0) return;
    this.entidadesSeleccionables = [];
    this.entidadesSeleccionables = this.contratoEntidades.map(e => {return {key: e.key, name: e.name}});
  }

  setEliminables(): void {
    if(!this.entidades || this.entidades.length <= 0) return;

    const entidadesValidadas = this.entidades.filter(e => e?.entidad && this.contratoEntidades.some(c => c?.key == e?.entidad)) || [];
    if(!entidadesValidadas || entidadesValidadas.length <= 0) return;

    this.eliminables = [];

    for(const entidad of entidadesValidadas) {
      const name = this.contratoEntidades.find(e => e?.key == entidad?.entidad);
      const entidadObj: Eliminable  = {
        entidadId: entidad?.entidad,
        entidad: name?.name || entidad?.entidad,
        ruts: [],
        rutsVisibles: [],
        pagina: 1,
        searchTerm: ''
      };

      if(entidad?.items && entidad?.items.length > 0) {
        for(const item of entidad?.items) {
          if(!item?.rut) continue;
          const element: RutEliminable = {
            rut: item?.rut,
            seleccionado: false,
            isNatural: this.personaNatural(item?.rut)
          }
          entidadObj.ruts.push(element);
        }
        entidadObj.rutsVisibles = entidadObj.ruts;
      }
      this.eliminables.push(entidadObj);
    }

  }

  personaNatural(rut: string): boolean{
    if (parseInt(rut.substring(0, this.rut.length - 1)) >= 50000000){
      return false;
    } else {
      return true;
    }
  }

  agregarEntidadForm(): void {
    if(!this.entidadSeleccionada) return;

    const contratoEntidad = this.contratoEntidades.find(e => e.key == this.entidadSeleccionada);
    if(!contratoEntidad || !contratoEntidad?.outputVars || contratoEntidad?.outputVars.length <= 0) return;

    const form = this.formBuilder.group({});

    for(const outputVar of contratoEntidad?.outputVars) {
      if(outputVar?.name == 'rut' || outputVar.name == 'Rut') {
        form.addControl('rut', this.formBuilder.control('', [Validators.required, gtpRutValidator()]));
      } else {
        const validadores = [Validators.required];
        if(outputVar?.length) {
          const length = outputVar?.length.split("-");
          length[0] != '' ? validadores.push(Validators.minLength(Number(length[0]))) : null;
          length[1] != '' ? validadores.push(Validators.maxLength(Number(length[1]))) : null;
        }
        form.addControl(outputVar?.name, this.formBuilder.control('', validadores));
      }
    }
    this.formComponent.push(
      {
        entidad: contratoEntidad?.name || '',
        entidadId: contratoEntidad?.key || '',
        form: form,
        outputVars: contratoEntidad?.outputVars || []
      }
    )
  }

  filtrarRut(item: Eliminable, searchTerm: string): void {
    const dataReal = item?.ruts;

    if (!searchTerm || searchTerm.trim() === '') {
      item.rutsVisibles = [...dataReal];
      return;
    }

    const search = searchTerm.replace(/[\.\- ]/g, '').toUpperCase();

    const filtrados = dataReal.filter(item => {
      const rutLimpio = item.rut ? item.rut.replace(/[\.\- ]/g, '').toUpperCase() : '';
      return rutLimpio.includes(search);
    });

    item.rutsVisibles = filtrados;
    item.pagina = 1;
  }

  eliminarEntidad(index: number): void {
    this.formComponent.splice(index, 1);
  }

  agregar(): void {
    if(!this.formComponent || this.formComponent.length <= 0) return;

    const payload: any[] = [];

    for(const element of this.formComponent) {
      if(!element?.form) continue;
      if(!element?.form?.valid) {
        this.addMessage('Complete correctamente los campos del formulario', true, false);
        return;
      }

      const formData = element?.form.getRawValue();
      if(!formData?.rut) continue;

      const item: any = {
        fuente: '',
        rut: this.utilsService.formatterRutV2(formData.rut.toUpperCase()),
        atributos: []
      };

      const atributos = element?.outputVars.filter(e => e.name != 'rut' && e.name != 'Rut') || [];
      if(atributos && atributos.length > 0) {
        for(const atributo of atributos) {
          atributo.value = formData?.[atributo.name] || formData?.[atributo.name] == '0' ? formData?.[atributo.name] : '';
        }
        item.atributos = atributos;
      }

      const entidadElement = payload.find(e => e.entidad == element.entidadId);
      if(entidadElement) {
        entidadElement.items.push(item)
      } else {
        payload.push({
          entidad: element.entidadId,
          name: element.entidad,
          items: [item]
        })
      }
    }

    if(!payload || payload.length <= 0) return;

    this.spinner.show();
    this.solicitudCreditoService.agregarBorrarDerivadas(this.rut, this.idTransaccion, true, payload).subscribe(
      resp => {
        this.formComponent = [];
        this.entidadSeleccionada = '';
        this.responseApi = resp; // para enviar al padre y que rearme todo
        this.entidades = resp?.SolicitudDeCredito?.Stage5Response?.Entidades;
        this.contratoEntidades = resp?.SolicitudDeCredito?.Stage5Response?.Contrato;
        this.setEntidadesSeleccionables();
        this.setEliminables();
        this.addMessage('Solicitud de Crédito - Elementos agregados correctamente', false, true);
        this.spinner.hide();
      }, 
      (error) => {
        this.addMessage('Solicitud de Crédito - Ocurrio un error al consultar servicio de agregar entidades', true, false);
        this.spinner.hide();

    });
    
  }

  eliminar(): void {
    if(!this.eliminables || this.eliminables.length <= 0) return;

    const request: any[] = [];
    for(const entidad of this.eliminables) {
      if(!entidad?.ruts || entidad?.ruts.length <= 0) continue;
      const seleccionados = entidad?.ruts.filter(e => e.seleccionado) || [];
      if(!seleccionados || seleccionados.length <= 0) continue;

      const entidadObj: any = {
        entidad: entidad.entidadId,
        items: []
      };

      for(const rutElement of seleccionados) {
        const rutEntidad = this.entidades.find(e => e.entidad == entidad.entidadId);
        if(rutEntidad?.items && rutEntidad?.items.length > 0) {
          const entidadEncontrada = rutEntidad.items.find((e: any) => e?.rut == rutElement?.rut);
          if(entidadEncontrada) {
            entidadObj.items.push(entidadEncontrada);
          }
        }
      }

      request.push(entidadObj);
    }

    if(!request || request.length <= 0) {
      this.addMessage('Seleccione por lo menos un rut para eliminar', true, false);
      return;
    }

    this.spinner.show();
    this.solicitudCreditoService.agregarBorrarDerivadas(this.rut, this.idTransaccion, false, request).subscribe(
      resp => {
        this.responseApi = resp; // para enviar al padre y que rearme todo
        this.entidades = resp?.SolicitudDeCredito?.Stage5Response?.Entidades;
        this.contratoEntidades = resp?.SolicitudDeCredito?.Stage5Response?.Contrato;
        this.setEntidadesSeleccionables();
        this.setEliminables();

        this.addMessage('Solicitud de Crédito - Elementos eliminados correctamente', false, true);
        this.spinner.hide();
      }, 
      (error) => {
        this.addMessage('Solicitud de Crédito - Ocurrio un error al consultar servicio de eliminar entidades', true, false);
        this.spinner.hide();
      });
  }

  resetToAgregar(): void {
    this.mostrarFormulario = true;
  }

  resetToEliminar(): void {
    this.formComponent = [];
    this.entidadSeleccionada = '';
    this.mostrarFormulario = false;
  }

  close() {
    this.dialogRef.close(this.responseApi);
  }

  addMessage(mensaje: string, isError: boolean, isSuccess: boolean) : void {
    this.messages.push({ text: mensaje, isError: isError, isSuccess: isSuccess });
  }

  removeMessage(index: number) {
    this.messages.splice(index, 1);
  }

}
